import { Card, Spin, Tabs, theme } from 'antd';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';

import { useAuth } from '@client/hooks/useAuth';
import { LoginSection } from '@client/pages/auth/login.section';
import { RegisterSection } from '@client/pages/auth/register.section';
import { useLoading } from '@client/store/loading.store';
import { ERoutePaths } from '@client/types/router.type';

export type TLogin = {
  email: string;
  password: string;
};

export type TRegister = {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  confirm: string;
};

/**
 * Auth page
 * @returns {React.JSX.Element} Auth page
 */
export default function AuthPage(): React.JSX.Element {
  const { loading } = useLoading();
  const { user, signInWithEmail, signInWithGoogle, registerWithEmail } =
    useAuth();
  const {
    token: { colorFillAlter },
  } = theme.useToken();

  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) {
      navigate(ERoutePaths.HOME);
    }
  }, [user, loading, navigate]);

  if (loading || (!loading && user)) {
    return <Spin fullscreen />;
  }

  const items = [
    {
      key: 'login',
      label: 'Login',
      children: (
        <LoginSection
          handleLogin={signInWithEmail}
          handleGoogleLogin={signInWithGoogle}
          loading={loading}
        />
      ),
    },
    {
      key: 'register',
      label: 'Register',
      children: (
        <RegisterSection handleRegister={registerWithEmail} loading={loading} />
      ),
    },
  ];

  return (
    <div
      style={{
        minWidth: 400,
        display: 'flex',
        justifyContent: 'center',
        margin: 'auto',
      }}
    >
      <Card
        variant={'outlined'}
        style={{ padding: 24, width: '100%', background: colorFillAlter }}
      >
        <Tabs defaultActiveKey="login" centered items={items} />
      </Card>
    </div>
  );
}
